import FormInputTypes from '../components/atoms/formEnums/formInputTypes';
import tableNewComposeExperienceUrls from './tableNewComposeExperienceUrls';
import tableNewComposeExperienceMulticam from './tableNewComposeExperienceMulticam';
import tableComposeExperienceMulticamFiles from './tableComposeExperienceMulticamFiles';
import MapConfigFields from './formGroupComposeExperience/formGroupComposeExperienceMapConfigurationFields';
import MapPreview from './formGroupLiveSteps/formGroupStep4CamerasPresentation/formGroup12MapPreview';
import { IconType } from '../components/atoms/icon/icon';
import tableMediaTagging from './formGroupLiveApps/tableMediaTagging';

export default {
  title: 'Meta Tags',
  attributeName: 'composeExperiencesTagging',
  refreshUpdate: false,
  fields: [    
    {
      attributeName: 'id',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'ID',
      hidden: true
    },
    {
        attributeName: 'mediaTagDomain',
        label: 'Domain',
        helpText: 'Set the main theme of the media.',
        default: '(Empty)',
        type: FormInputTypes.SELECT,
        options: [ 
         { name: '(No action)', value: '(Empty)' },
         { name: 'Sports', value: 'sports' },
         { name: 'Music', value: 'music' },
         { name: 'Tourism', value: 'tourism' },
         { name: 'Art', value: 'art' },
         { name: 'Acting', value: 'acting' },
         { name: 'Cinema', value: 'cinema' },
         { name: 'Theatre', value: 'theatre' },
         { name: 'Dance', value: 'dance' },
         { name: 'Education', value: 'education' },
         { name: 'Technology', value: 'technology' }
      ],
        // className: 'col-sm-4',
    },
    {
      attributeName: 'mediaTagCategory',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Category',
      helpText: 'Category of the media tag eg: football, basketball, tennis.',
      placeholder: 'football, basketball, tennis...',
      // className: 'col-sm-4',
    },
    {
      attributeName: 'composeExperienceTags',
      type: FormInputTypes.TABLECOMPONENT,
      mode:'POPUP',
      helpText: '',
      configFile: tableMediaTagging,
      onAfterEdit: (row, dispatch, updateForm,initialValuesRef) => {
        let value = {
          ... initialValuesRef.current,
          ...row
        }
        dispatch(updateForm(value));
        initialValuesRef.current = null;
      }
    },
  ],
};
